import {useEffect} from 'react';
import useUnreadNotification from '@di-shared/features/diag/useUnreadNotification';

interface HomeSestExchangeHistoryKrProps {
  vin: string;
}

function HomeSestExchangeHistoryKr({vin}: HomeSestExchangeHistoryKrProps) {
  const {checkUnreadServiceCenterNotifications, checkUnreadUserNotifications} = useUnreadNotification(vin);
  useEffect(() => {
    (async function () {
      await checkUnreadServiceCenterNotifications();
      await checkUnreadUserNotifications();
    })();
  }, []);

  return null;
}

export default HomeSestExchangeHistoryKr;
